export enum Cookies {
  culture = '__culture',
  accountView = '__accountView',
  ipInfo = '__ipInfo',
}

class CookieService {
  getCookie = (cname: string): string => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];

      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  setCookie = (name: string, value: string, path?: string, maxAgeSeconds?: number): void => {
    const val = encodeURIComponent(value);
    let cookie = `${name}=${val}`;

    if (maxAgeSeconds) {
      cookie += `; max-age=${maxAgeSeconds}`;
    }

    if (path) {
      cookie += `; path=${path}`;
    }

    document.cookie = cookie;
  };
}

export const cookieService = new CookieService();
